/* istanbul ignore file */
import { createGlobalStyle, css } from 'styled-components';
import { normalize } from 'polished';
var StyledGlobalStyle = createGlobalStyle(["", " ", " ", " *{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;}"], normalizeStyle, borderBox, fonts);

function borderBox(props) {
  return props.borderBox && css(["*,*:before,*:after{box-sizing:border-box;}"]);
}

function normalizeStyle(props) {
  return props.normalize && normalize();
}

function fonts(props) {
  if (typeof window === 'undefined' || !props.fonts) {
    return;
  }

  var fontFaces = Object.keys(props.fontFace).map(function (face) {
    return props.fontFace[face];
  }).join('\n');
  return css(["", ""], fontFaces);
}

export default StyledGlobalStyle;